import { Box, Label, Tag } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { InterfaceNameValue, RadioButtonGroup } from '@tiendanube/components';

interface OrdersWholesaleFilterProps {
  value: string;
  onChange: ({ name, value }) => void;
}

export default function OrdersWholesaleFilter({
  value,
  onChange,
}: Readonly<OrdersWholesaleFilterProps>) {
  const { t } = useTranslation(Domain.ORDERS);
  const tPath = 'filters.b2bFilter';

  const options = [
    {
      label: t(`${tPath}.all`),
      value: '',
    },
    {
      label: t(`${tPath}.retail`),
      value: 'false',
    },
    {
      label: t(`${tPath}.wholesale`),
      value: 'true',
    },
  ];

  const handleRadioChange = (e: InterfaceNameValue) => {
    onChange({ name: 'isWholesale', value: e.value });
  };

  return (
    <Box borderStyle="none">
      <Box paddingBottom="2" display="flex" alignItems="center" gap="1">
        <Label>{t(`${tPath}.label`)}</Label>
        <Tag appearance="primary">{t(`${tPath}.tag`)}</Tag>
      </Box>
      <Box>
        <RadioButtonGroup
          name="isWholesale"
          options={options}
          onChange={handleRadioChange}
          value={value}
        />
      </Box>
    </Box>
  );
}
